import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

 @Component({
   selector: 'not-implemented-dialog',
   templateUrl: 'not-implemented-dialog.html',
   encapsulation: ViewEncapsulation.None
  })
 export class NotImplementedDialog implements OnInit {

   public title: string = "";
   public body: string = "";
 
   ngOnInit(): void {

     this.title = this.data.selectedTitle;
     this.body = this.data.selectedText;
   }

    constructor(
      public dialogRef: MatDialogRef<NotImplementedDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}
    
      onNoClick(): void {
        this.dialogRef.close();
     }

     onSaveClose(): void {


       //close windows
       this.dialogRef.close("ok");


     }

     

  }
